import React from 'react';
import { setRef } from '@sheerid/jslib';

interface CheckBoxInputProps {
    isErrored: boolean;
    onChange: Function;
    value: boolean;
}

const CheckBoxInput = ({
    isErrored,
    onChange,
    value,
}: CheckBoxInputProps) => (
    <div className="sid-checkbox">
        <input
            className="sid-checkbox__input"
            id="parentalConsent"
            name="parentalConsent"
            type="checkbox"
            checked={value}
            ref={ref => setRef('parentalConsent', ref)}
            onChange={e => onChange(e.target.checked)}
        />
        <span className={`sid-checkbox__input-like ${isErrored ? 'sid-checkbox__input-like--error' : ''}`} />
    </div>
);

export const CheckBoxInputComponent = CheckBoxInput;
